<template>
  <div>
    <div class="voice-record">
      <button @click="recordAudio" type="button" class="btn btn-danger">
        {{ $t("record") }}
      </button>
      <button @click="stop" type="button" class="btn btn-success">
        {{ $t("stop") }}
      </button>
    </div>
    {{ audioUrl }}
    <div class="play-back">
      <audio ref="audioPlayer" preload="auto" src="" autoplay controls></audio>
    </div>
  </div>
</template>

<script>
export default {
  name: "MySprkr",
  data() {
    return {
      recorder: null,
      device: null,
      audioUrl: "",
      items: []
    };
  },
  methods: {
    stop() {
      this.recorder.stop();
    },
    recordAudio() {
      this.device = navigator.mediaDevices.getUserMedia({ audio: true });
      this.items = [];
      this.device.then(stream => {
        this.recorder = new MediaRecorder(stream);
        this.recorder.start();

        this.recorder.addEventListener("dataavailable", event => {
          this.items.push(event.data);
        });

        this.recorder.addEventListener("stop", () => {
          const audioBlob = new Blob(this.items);
          this.audioUrl = URL.createObjectURL(audioBlob);
          const audio = new Audio(this.audioUrl);
          audio.play();
          this.$refs.audioPlayer.src = this.audioUrl;
          this.$refs.audioPlayer.load();
        });
      });
    }
  }
};
</script>
<style lang="scss">
.voice-record {
  padding: 18px;
  display: flex;
  justify-content: space-around;
}
.play-back {
  padding: 18px;
  display: flex;
  justify-content: center;
}
</style>
